<template>
    <ui-modal
        size="xs"
        :name="name"
        :title="title"
        :icon="icon"
        :load="loader.modalLoad"
        :load-success="loader.modalLoadSuccess"
		:show-close-option="showCloseModalButton">

        <div>
            <ui-overlay-load v-if="load" />
            <ui-select-procedure v-if="layout.showProcedures" v-model="proceduresComputed" :load="loader.procedures" />
            <div v-else class="message">Clique para finalizar sua proposta.</div>
            <slot />
        </div>

        <div slot="footer">
			<ui-button v-if="layout.showProcedures" design="link" @click="cancelButtonHandler" :disabled="layout.submitButtonLoad">Cancelar</ui-button>
            <ui-button v-if="layout.showProcedures" design="md success mw-100" :disabled="layout.isDisableSubmit" @click="submit" :loading="loader.submitButtonLoad">Enviar <i class="fal fa-long-arrow-right"/></ui-button>
            <ui-button v-else design="md success mw-100" @click="finish" :loading="loader.finishButtonLoad">Finalizar <i class="fal fa-long-arrow-right"/></ui-button>        </div>
    </ui-modal>
</template>

<script>
	import { uiModal } from "@/components/ui/modal"
	import { uiButton } from "@/components/ui/buttons"
	import { uiOverlayLoad } from '@/components/ui'
	import uiSelectProcedure from '@/components/ui-facilita/sales/select-procedure'

	import { storage } from '@/services/storage'
	import { deal, configuration, reserve } from '@/services/axios'
	import { mapGetters } from 'vuex'

	import helpers from '@/mixins/helpers'
 
	const defaultLayout = () => {
		return {
			isDisableSubmit: true,
			showProcedures: true,
		}
	}

	const defaultLoader = () => {
		return {
			procedures: true,
			modalLoad: false,
			modalLoadSuccess: false,
			submitButtonLoad: false,
			finishButtonLoad: false,
		}
	}

	export default {
		name: 'ui-procedure',

		components: {
			uiModal,
			uiButton,
			uiOverlayLoad,
			uiSelectProcedure,
		},

		mixins: [helpers],

		props: {
			/**
			 * Propriedade referente ao ID do cliente, para se buscar os
			 * procedimentos
			 */
			id: {
				type: [String, Number],
				required: true
			},

			/**
			 * Propriedade que identifica qual guia está acessando a tela de procedimentos
			 */
			guide: {
				type: String,
				required: true
			},

			/**
			 * Propriedade referente ao componente modal
			 */
			name: {
				type: String,
				required: false,
				default: 'sales-procedure'
			},
			/**
			 * Propriedade referente ao componente modal
			 */
			title: {
				type: String,
				required: false,
				default: 'Enviar Simulação de Proposta'
			},

			/**
			 * Propriedade referente ao componente modal
			 */
			icon: {
				type: String,
				required: false,
				default: 'fal fa-cogs'
			},

			/**
			 * Define o load usado no component
			 * mostrado apenas na parte do conteúdo e não no menu lateral
			 */
			load: {
				type: Boolean,
				default: false,
				required: false
			},

			/**
			 * Define qual a etapa pré-selecionada
			 */
			default: {
				type: Number,
				default: 0,
				required: false
			}
		},

		data() {
			return {
				procedure: null,
				deal: null,
				showCloseModalButton: false,
				procedures: [],
				configurations: null,
				guideData: null,
				layout: {
					isDisableSubmit: true,
					showProcedures: true,
				},

				loader: {
					procedures: true,
					modalLoad: false,
					modalLoadSuccess: false,
					finishButtonLoad: false,
					submitButtonLoad: false,
				},
			}
		},

		created() {
			/**
			 * Ao abrir o modal inicia o laod dos procedimentos
			 * Os paramentros de loadings e laytout são resetados
			 */
			this.$root.$on("modal-open-" + this.name, async () => {
				this.resetLayout()
				this.resetLoader()
				await this.loadProcedures()
			})
		},

		mounted: async function () {
			/** Carrega as configurações de proposta */
			await configuration.getConfigurations().then(response => {
				let data = response.data
				for (var prop in data) {
					if(data.hasOwnProperty(prop)) {
						switch (data[prop].name) {							
							case 'proposalSettings':
								this.configurations = data[prop].value_long
								break
						}
					}
				}
			})
		},

		beforeDestroy() {
			this.$root.$off('modal-open-' + this.name)
		},

		computed: {
			...mapGetters('auth', {
				user: 'getUser'
			}),

			proceduresComputed: {
				get() {
					return this.procedures
				},

				set(value) {
					this.procedure = value
					this.$set(this.layout, 'isDisableSubmit', false)
				}
			}
		},

		methods: {
			/**
			 * Recebe os dados dos responsáveis de um negócio, e retorna o ID adequado
			 * para fazer a reserva
			 */
			prepareReservedUserId(owners){
				let reserved_user_id = null

				if (owners.broker_id) {
					reserved_user_id = owners.broker.user_id

				} else if (owners.manager_id) {
					reserved_user_id = owners.manager.user_id || owners.manager.id

				} else if (owners.owner_id) {
					reserved_user_id = owners.owner_id
				}

				return reserved_user_id
			},

			/**
			 * Utiliza dos dados do negócio para criar uma reserva de acordo com
			 * as regras definidas na etapa 2 do empreendimento
			 */
			reserve() {
				let dataReserve = null

				if (this.configurations &&
					this.configurations.reserve &&
					this.configurations.reserve.active == 'yes' &&
					this.deal.unity &&
					this.deal.unity.id &&
					this.deal.product_id) {
					let product = null
					let availability = null
					let time = null
					let infos = null

					if (this.deal.product) {
						product = this.deal.product
						availability = this.deal.product.availability

					} else if (this.deal.product_without_global_scopes) {
						product = this.deal.product_without_global_scopes
						availability = this.deal.product_without_global_scopes.availability
					}

					if (availability && availability.infos) {
						infos = availability.infos

					} else if (product && product.infos) {
						infos = product.infos
					}

					if (this.configurations.reserve.time) {
						time = this.configurations.reserve.time

					} else {
						time = infos && infos.reserve && infos.reserve.times ? infos.reserve.times[0] : '24:00'
					}

					dataReserve = {
						unity_id: this.deal.unity.id,
						block: this.deal.unity.id,
						product_id: this.deal.product_id,
						deal_id: this.deal.id,
						expire_time: time,
						reserved_user_id: this.prepareReservedUserId(this.deal.owners)
					}

					if (infos && infos.reserve && infos.reserve.integration === 'apiuau') {
						dataReserve.integration = {
							business: infos.uauBusinessKey,
							product: infos.uauProductKey
						}

						if (infos.uauProductType == 'vertical') {
							dataReserve.number = this.guideData.step5 && this.guideData.step5.options
								? this.guideData.step5.options.split('@')[2]
								: []
							dataReserve.floor = this.guideData.step6 ? this.guideData.step6.floor : null

						} else {
							dataReserve.number = this.guideData.step5 && this.guideData.step5.options
								? this.guideData.step5.options.split('@')[1]
								: []
						}

					} else {
						dataReserve.number = this.deal.unity.number
						if (availability && availability.type == 'vertical') dataReserve.floor = this.deal.unity.floor
					}
				}

				return new Promise((resolve, reject) => {
					if (dataReserve) {
						reserve.create('', dataReserve)
							.then(response => {
								this.$toastr.s(response.data.msg)

								resolve(response)
							})
							.catch(error => {
								if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
								console.log('error', error)

								reject(error)
							})

					} else {
						resolve()
					}
				})
			},

			submit() {
				/**
                 * Emite o evento do Google Analytics
                 */
                this.$gtm.trackEvent({
                    event: "fac_button_click",
                    category: "vuejs-simular proposta",
                    action: "click",
                    label: "Botão Enviar",
                })

				/**
				 * Habilita o loading no botão 'Enviar'
				 */
				 this.$set(this.loader, 'submitButtonLoad', true)

				if (this.deal && this.deal.id && this.procedure) {
					this.reserve().finally(() => {
						this.$emit('submit', { procedure: this.procedure, deal: this.deal.id })
						this.$set(this.loader, 'modalLoadSuccess', true)
					})

				} else {
                    this.$toastr.e('Falha ao selecionar um procedimento')
					/**
					 * Desabilita o loading no botão 'Enviar'
					 */
					this.$set(this.loader, 'submitButtonLoad', false)
                }
			},
			
			/**
			 * Finaliza quando não tem procedimentos enviando para a interna do negócio
			 */
			finish: async function () {
				/**
                 * Emite o evento do Google Analytics
                 */
                this.$gtm.trackEvent({
                    event: "fac_button_click",
                    category: "vuejs-simular proposta",
                    action: "click",
                    label: "Botão Finalizar",
                })
				/**
				 * Habilita o loading no botão 'Finalizar'
				 */
				 this.$set(this.loader, 'finishButtonLoad', true)

				/** Verifica se os dados do negócio contidos no localStorage pertencem ao cliente informado na rota */
				if (this.deal && this.deal.id && parseInt(this.deal.customer_id) === parseInt(this.id)) {
					/** Verifica se existem configurações de etapa e status para simulação ou proposta */
					let params = null
					switch (this.guide) {
						case 'proposta':
							if (this.configurations &&
								this.configurations.proposal &&
								this.configurations.proposal.funnel_end &&
								this.configurations.proposal.funnel_end.stage_id) {
								params = {
									funnel_stage_id: this.configurations.proposal.funnel_end.stage_id,
									funnel_stage_status_id: this.configurations.proposal.funnel_end.status_id
								}								
							}
							break
					
						case 'simulacao':
							if (this.configurations &&
								this.configurations.simulation &&
								this.configurations.simulation.funnel_end &&
								this.configurations.simulation.funnel_end.stage_id) {
								params = {
									funnel_stage_id: this.configurations.simulation.funnel_end.stage_id,
									funnel_stage_status_id: this.configurations.simulation.funnel_end.status_id
								}								
							}
							break
					}

					if (params) {
						await deal.update(this.deal.id, '/move', params)
							.then((response) => {
								this.$toastr.s(response.data.msg)
							})
							.catch((error) => {
								if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
								console.log('error', error)
							})
					}

					this.reserve().finally(() => {
						this.oldPanelLinkButton(`/vendas/negocios/${this.deal.id}`)
					})

				} else {
					/**
					 * Desabilita  o loading no botão 'Finalizar'
					 * Envia toast com erro
					 */
					 this.$set(this.loader, 'finishButtonLoad', false)
					this.$toastr.e('Os dados do cliente selecionado não são válidos')
				}
			},

			/**
			 * Carrega os dados dos procedimentos de acordo com o ID do cliente
			 */
			loadProcedures() {

				return new Promise((resolve, reject) => {
					this.$set(this.loader, 'procedures', true)

					/**
					 * Busca os dados no local storage de acordo com a chave definida pelo guia que
					 * redirecionou para a tela de procedimentos
					 */
					switch (this.guide) {
						case 'proposta':
							this.guideData = JSON.parse(storage.getLegacy(`guide_proposalNew_${this.user.id}`))
							this.deal = this.guideData.step5.deal || { id: this.guideData.step5.deal_id }
							break
					
						case 'simulacao':
							this.guideData = JSON.parse(storage.getLegacy(`guide_simulationNew_${this.user.id}`))
							this.deal = this.guideData.deal
							break
					}

					if (this.deal && parseInt(this.deal.customer_id) === parseInt(this.id)) {
						/**
						 * Verifica se os dados dos procedimentos já estão inclusos no localStorage, e se estes
						 * se referem ao cliente passado como parâmetro
						 */
						if (this.deal.procedure) {
							setTimeout(() => {
								/** Pega os procedimentos/botões do negócio */
								this.procedures = []
								for (const procedure of this.deal.procedure) {
									this.procedures = this.procedures.concat(procedure.buttons)
								}

								resolve()
							}, 809)
						
						/**
						 * Caso os dados dos procedimentos não constem no localStorage, realiza uma requisição para
						 * buscar os dados
						 */
						} else if (this.deal.id) {
							deal.get(this.id, '/active')
								.then(response => {
									/** Busca o negócio desejado entre os negócios ativos do cliente */
									this.deal = Object.values(response.data).find(item => parseInt(item.id) === parseInt(this.deal.id))
									/**
									 * Caso o negócio possua procedimentos, monta o select de procedimentos com
									 * os botões do procedimento
									 */
									if (this.deal && this.deal.procedure) {
										this.procedures = []
										for (const procedure of this.deal.procedure) {
											this.procedures = this.procedures.concat(procedure.buttons)
										}
									}

									resolve()
								})
								.catch(error => {
									this.procedures = []
									if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
									console.log('error', error)
									reject()
								})

						} else {
							reject()
						}

					} else {
						reject()
					}
				})
				.finally(() => {
					this.$set(this.loader, 'procedures', false)
					if (!this.procedures.length) this.$set(this.layout, 'showProcedures', false)

				})
			},

			/**
			 * Reseta o layout
			 */
			resetLayout() {
				this.layout = {
					...defaultLayout()
				}
			},

			/**
			 * Reseta os loadings
			 */
			resetLoader() {
				this.loader = {
					...defaultLoader()
				}
			},

            close() {
                this.$root.$emit('modal-close-' + this.name)
            },
			/**
			 * Desativa a prop @param showProcedures, que é a condicional responsável por renderizar
			 * as opções de procedures dentro do modal.
			 */
			 cancelButtonHandler() {
				this.$set(this.layout, 'showProcedures', false)
			},
		}
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>